import React from 'react'
import { useTranslation } from 'react-i18next'

import { Message } from 'semantic-ui-react'

const Messages: React.FC<any> = props => {
  const { t } = useTranslation()
  const { error, success, errorMessage, successMessage } = props

  return (
    <React.Fragment>
      {error && errorMessage && <Message negative>{t(errorMessage)}</Message>}
      {success && successMessage && <Message success>{t(successMessage)}</Message>}
    </React.Fragment>
  )
}

export default Messages
